import {Action as ActionModel} from '@ngrx/store';
import {Alert} from '../../../core/model/alert';

export enum AlertsActionType {
  GET = '[Alerts] Get',
  GET_SUCCESS = '[Alerts] Get :: Success',

  GET_COUNT = '[Alerts] Get Count',
  GET_COUNT_SUCCESS = '[Alerts] Get Count :: Success',

  DISMISS = '[Alerts] Dismiss',

  CLEAR = '[Alerts] Clear',
}

export class GetAlertsAction implements ActionModel {
  public readonly type = AlertsActionType.GET;

  public constructor(
    public payload: {
      onSuccess?: (alerts: string[]) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class GetAlertsSuccessAction implements ActionModel {
  public readonly type = AlertsActionType.GET_SUCCESS;

  public constructor(public payload: {alerts: Alert[]}) {}
}

export class GetAlertsCountAction implements ActionModel {
  public readonly type = AlertsActionType.GET_COUNT;

  public constructor(
    public payload: {
      onSuccess?: (count: number) => void;
      onFailure?: (error: Error) => void;
    } = {}
  ) {}
}

export class GetAlertsCountSuccessAction implements ActionModel {
  public readonly type = AlertsActionType.GET_COUNT_SUCCESS;

  public constructor(public payload: {count: number}) {}
}

export class DismissAlertAction implements ActionModel {
  public readonly type = AlertsActionType.DISMISS;

  public constructor(
    public payload: {
      alertId: string;
      onSuccess?: () => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class ClearAlertsAction implements ActionModel {
  public readonly type = AlertsActionType.CLEAR;
}

export type AlertsAction =
  | GetAlertsAction
  | GetAlertsSuccessAction
  | GetAlertsCountAction
  | GetAlertsCountSuccessAction
  | DismissAlertAction
  | ClearAlertsAction;
